<template>
  <div class="container mx-auto flex">
    <div class="w-cta-slogan max-w-full">
      <h1 class="text-4xl font-bold">
        Elektrotechniek Van Hove
      </h1>
      <h2 class="text-2xl font-light">
        Professioneel werk met een persoonlijke aanpak
      </h2>
      <button
        @click="toContact"
        class="bg-secondary-0 rounded-full py-2 px-5 mt-1 text-primary-0
      hover:bg-primary-0 hover:text-secondary-0 transition-colors duration-150"
      >
        Neem nu contact op!
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallToAction',
  methods: {
    toContact() {
      window.location = '#contact';
    },
  },
};
</script>
